import { useWordPressPosts } from "./hook/wordpress/posts.wordpress.hook";
import { BrowserRouter, Route, Routes } from "react-router";
import Posts from "./pages/Posts";
import Login from "./pages/AuthenticationPages/Login";
import { useAuthStore } from "./store/auth.store";
import { useEffect, useState } from "react";
import { useMe } from "./hook/partner/authentication/me.partner.hook";
import { Layout } from "./components/Layout";
import { useInvoices } from "./hook/partner/invoices.partner.hook";
import Invoices from "./pages/Invoices";
import Opportunities from "./pages/Opportunities";
import Opportunity from "./pages/Opportunity";
import Deals from "./pages/Deals";
import Vendors from "./pages/Vendors";
import Vendor from "./pages/Vendor";
import Renewals from "./pages/Renewals";
import Deal from "./pages/Deal";
import Event from "./pages/Event";
import Events from "./pages/Events";
import Loans from "./pages/Loans";
import Loan from "./pages/Loan";
import Settings from "./pages/Settings";
import ProductSets from "./pages/ProductSets";
import WarehouseSale from "./pages/WarehouseSale";
import Dashboard from "./pages/Dashboard";
// import Marketing from "./pages/Marketing"; // Marketing dočasně skrytý
import Contacts from "./pages/Contacts";
import { useRefreshToken } from "./hook/partner/authentication/refreshToken.partner.hook";
import PasswordRecovery from "./pages/AuthenticationPages/PasswordRecovery";
import BusinessStats from "./pages/BusinessStats";
import SoldSN from "./pages/SoldSN";
import FortinetUnregistered from "./pages/FortinetUnregisteredLicenses";
import Klienti from "./pages/Klienti";
import Klient from "./pages/Klient";
import ChangePassword from "./pages/ChangePassword";
import Registration from "./pages/AuthenticationPages/Registration";
import Claims from "./pages/Claims";
import Claim from "./pages/Claim";

function App() {
  //console.log(posts);
  const token = useAuthStore((state) => state.token);
  const clearAuth = useAuthStore((state) => state.clearAuth);
  const meMutation = useMe();
  const refreshTokenMutation = useRefreshToken();
  const [runnigRefreshToken, setRunnigRefreshToken] = useState(null);

  useEffect(() => {
    if (token) {
      meMutation.mutate(token, {
        onSuccess: (data) => {
          if ("code" in data && data.code === 401) {
            clearAuth();
          }
        },
      });

      if (runnigRefreshToken !== null) {
        clearInterval(runnigRefreshToken);
      }
      const interval = setInterval(() => {
        let token = localStorage.getItem("token");
        if (token) {
          refreshTokenMutation.mutate(token);
        }
      }, 1000 * 60 * 10); // 10 minut
      setRunnigRefreshToken(interval);
    }
  }, [token]);

  return (
    <BrowserRouter>
      {token ? (
        <Layout>
          <Routes>
            <Route
                exact="true"
                path="/zapomenute-heslo/:email/:code"
                element={<ChangePassword />}
            />
            <Route
              exact="true"
              path="/zmena-hesla"
              element={<ChangePassword />}
            />
            <Route exact="true" path="/obnovy-licenci" element={<Renewals />} />
            <Route exact="true" path="/faktury" element={<Invoices />} />
            <Route
              exact="true"
              path="/prilezitost/:id"
              element={<Opportunity />}
            />
            <Route
              exact="true"
              path="/prilezitosti"
              element={<Opportunities />}
            />
            <Route
              exact="true"
              path="/produkty/:vendorId/:directoryId"
              element={<Vendors />}
            />
            <Route
              exact="true"
              path="/produkty/:vendorId"
              element={<Vendor />}
            />
            <Route exact="true" path="/produkty" element={<Vendors />} />
            <Route exact="true" path="/deal/:id" element={<Deal />} />
            <Route exact="true" path="/dealy" element={<Deals />} />
            <Route exact="true" path="/zapujcka/:id" element={<Loan />} />
            <Route exact="true" path="/zapujcky" element={<Loans />} />
            <Route exact="true" path="/akce/:eventId" element={<Event />} />
            <Route exact="true" path="/akce" element={<Events />} />
            <Route exact="true" path="/nastaveni" element={<Settings />} />
            <Route
              exact="true"
              path="/samoobsluha/:vendorId"
              element={<ProductSets />}
            />
            <Route exact="true" path="/samoobsluha" element={<ProductSets />} />
            <Route
              exact="true"
              path="/vyprodej/:vendorId"
              element={<WarehouseSale />}
            />
            <Route exact="true" path="/vyprodej" element={<WarehouseSale />} />
            {/*<Route exact="true" path="/marketing" element={<Marketing />} />*/}
            <Route exact="true" path="/kontakty" element={<Contacts />} />
            <Route exact="true" path="/prodana-sn" element={<SoldSN />} />
            <Route
              exact="true"
              path="/fortinet/neregistrovane-licence"
              element={<FortinetUnregistered />}
            />
            <Route
              exact="true"
              path="/statistika-obchodu"
              element={<BusinessStats />}
            />
            <Route exact="true" path="/klienti" element={<Klienti />} />
            <Route
              exact="true"
              path="/klient/:client_id"
              element={<Klient />}
            />
            <Route exact="true" path="/reklamace" element={<Claims />} />
            <Route
              exact="true"
              path="/reklamace/:id"
              element={<Claim />}
            />
            <Route
                exact="true"
                path="/zapomenute-heslo/:email/:code"
                element={<PasswordRecovery />}
            />
            <Route exact="true" path="/" element={<Dashboard />} />
          </Routes>
        </Layout>
      ) : (
        <Routes>
          <Route exact="true" path="/registrace" element={<Registration />} />
          <Route
              exact="true"
              path="/zapomenute-heslo/:email/:code"
              element={<PasswordRecovery />}
          />
          <Route
            exact="true"
            path="/zapomenute-heslo"
            element={<PasswordRecovery />}
          />
          <Route path="*" element={<Login />} />
        </Routes>
      )}
    </BrowserRouter>
  );
}

export default App;
